import * as React from "react";

import access from "../../resources/states/no-access.svg";
import bank from "../..//resources/states/no-bank.svg";
import conversation from "../../resources/states/no-conversation.svg";
import dashboard from "../../resources/states/no-dashboard.svg";
import data from "../../resources/states/no-data.svg";
import event from "../../resources/states/no-event.svg";
import favourite from "../../resources/states/no-favourite.svg";
import image from "../../resources/states/no-image.svg";
import location from "../..//resources/states/no-location.svg";
import logged from "../../resources/states/no-logged.svg";
import messages from "../../resources/states/no-messages.svg";
import networks from "../../resources/states/no-networks.svg";
import notification from "../../resources/states/no-notification.svg";
import product from "../../resources/states/no-product.svg";
import result from "../../resources/states/no-result.svg";
import task from "../../resources/states/no-task.svg";
import templates from "../../resources/states/no-templates.svg";
import trash from "../../resources/states/no-trash.svg";
import wallet from "../../resources/states/no-wallet.svg";
import {classNames} from "../../utils/Utils";

export const NO_ACCESS = 'access'
export const NO_BANK = 'bank'
export const NO_CONVERSATION = 'conversation'
export const NO_DASHBOARD = 'dashboard'
export const NO_DATA = 'data'
export const NO_EVENT = 'event'
export const NO_FAVOURTIRE = 'favourite'
export const NO_IMAGE = 'image'
export const NO_LOCATION = 'location'
export const NO_LOGGED = 'logged'
export const NO_MESSAGES = 'messages'
export const NO_NETWORKS = 'networks'
export const NO_NOTIFICATION = 'notification'
export const NO_PRODUCT = 'product'
export const NO_RESULT = 'result'
export const NO_TASK = 'task'
export const NO_TEMPLATES = 'templates'
export const NO_TRASH = 'trash'
export const NO_WALLET = 'wallet'


export default function EmptyState({className = '', title = null, description = null, type, isActive = false, children, iconWidth}) {

    const getIconByType = () => {
      switch (type) {
          case NO_ACCESS:
              return access
          case NO_BANK:
              return bank
          case NO_CONVERSATION:
              return conversation
          case NO_DASHBOARD:
              return dashboard
          case NO_DATA:
              return data
          case NO_EVENT:
              return event
          case NO_FAVOURTIRE:
              return favourite
          case NO_IMAGE:
              return image
          case NO_LOCATION:
              return location
          case NO_LOGGED:
              return logged
          case NO_MESSAGES:
              return messages
          case NO_NETWORKS:
              return networks
          case NO_NOTIFICATION:
              return notification
          case NO_PRODUCT:
              return product
          case NO_RESULT:
              return result
          case NO_TASK:
              return task
          case NO_TEMPLATES:
              return templates
          case NO_TRASH:
              return trash
          case NO_WALLET:
              return wallet
          default:
              return '#'
      }
    }

    return (
        isActive ? (
            <div className={classNames("flex flex-col before:flex-1 after:flex-1  h-full text-center text-sm py-5", className)}>
                <div>
                    <img src={getIconByType()} alt={''} className={classNames(iconWidth ? iconWidth : 'w-[100px]', "mx-auto")}/>
                    {
                        title && (
                            <h2 className="mt-1 text-center text-gray-800  leading-8  text-md ">
                                {title}
                            </h2>
                        )
                    }
                    {
                        description && (
                            <p className={classNames(!title && "mt-1", "max-w-xl text-gray-500 mx-auto text-center text-sm ")}>
                                {description}
                            </p>
                        )
                    }
                </div>
            </div>
        ) : (
            <>{children}</>
        )
    )
}
